/**
 * Волна D (docs/MIGRATION_ROUTER.md §5).
 * Было: <PrivateRoute path='/cabinet' redirectPathname='/'>.
 * Фаза 5: PrivateRoute удалён — auth-гард через authGuardShell
 * (аноним → Redirect '/'; вложенный Switch PersonalArea — через
 * универсальный Switch compat-слоя).
 */
import { createFileRoute } from '@tanstack/react-router';
import { authGuardShell } from '../compat/shells';
import PersonalArea from '@routes/PersonalArea';

export const Route = createFileRoute('/cabinet/')({
  component: authGuardShell(PersonalArea, '/cabinet')
});
